<script>
  import { Converter } from '@/models/converter'
  import ModelMapper from '@/mixins/ModelMapper'
  import EntityProxy from '@/models/EntityProxy'

  const toSnakeCase = string => {
    return new Converter({
      data: string,
      converterName: 'snakecase'
      }).perform()
  }

  export default {
    computed: {
      disabledSaveButton() {
        return  !this.currentCompany.uf ||
                !this.currentCompany.name ||
                !this.currentCompany.cnpj
      },
      hasCertificate() {
        return this.currentCompany && this.currentCompany.certificateExpiringAt
      },
      hasTempCertificate() {
        return this.currentCompany && this.currentCompany.digitalCertificate
      }
    },
    created() {
      this.currentCompany = EntityProxy.clone(this.company, { digital_certificate: false })
    },
    data() {
      return {
        currentCompany: null,
        nameModel: 'Company'
      }
    },
    methods: {
      buildData() {
        let formData = new FormData()
        this.currentCompany.each((key, value) => {
          key = toSnakeCase(key)
          if (key === 'services')
            return

          if ([null, undefined].includes(value))
            formData.append(key, '')
          else if (typeof value !== 'object' || value instanceof File)
            formData.append(key, value)
        })
        return formData
      },
      buildHeaders() {
        return { 'Content-Type': 'multipart/form-data' }
      },
      cancel() {
        this.clear()
        this.$emit('cancelSaveCompany')
      },
      clear() {
        this.currentCompany = EntityProxy.clone(this.company)
        this.currentCompany.digitalCertificate = false
      },
      formatFileSize(file) {
        return `${(file.size / 1024).toFixed(2)} KB`.replace('.', ',')
      },
      infoIE() {
        return 'Caso este campo não seja preenchido, iremos considerar o estabelecimento como isento, ok?'
      },
      removeCertificate() {
        if (!window.confirm('Tem certeza que quer remover o certificado?'))
          return

        this.openGlobalLoad()
        this.axios.put(`companies/${this.currentCompany.id}`, { remove_certificate: true })
          .then((response) => this.currentCompany = EntityProxy.build(response.data))
          .then(() => this.$emit('saveCompany', this.currentCompany))
          .then(() => this.cancel())
          .then(() => this.$notify.add('O certificado digital foi removido', { type: 'success' }))
          .catch((e) => this.$notify.addError(e))
          .finally(() => this.closeGlobalLoad())
      },
      save() {
        this.asyncTemplateSave(this.currentCompany, {
          after: ({model}) => {
            this.currentCompany = model
            this.$emit('saveCompany', model)
            this.$notify.add('Salvo com sucesso!')
            this.cancel()
          }
        })
      },
      setFile(files) {
        this.$set(this.currentCompany, 'digitalCertificate', files[0])
      }
    },
    mixins: [ModelMapper],
    name: 'MethodMixins',
    props: {
      company: { required: true, type: Object }
    }
  }
</script>
